<template>
  <div class="relative">
    <header>
      <div class="container-fluid border-b border-gray-200 pr-8 pl-8 fm:pr-4 fm:pl-4 fd:fixed z-100 w-full bg-white pt-4">
        <!--    Nav bar-->
        <div class="flex flex-col gap-8 container mx-auto">
          <div :class="['flex flex-row justify-between items-center', scrollY >= 400 && scrollIsDown ? 'pb-5' : '']">
            <span class="fd:hidden" @click="$store.state.showNav = true">
              <font-awesome-icon icon="fa-solid fa-bars" class="icon font-medium fm:text-sm"/>
            </span>

            <div class="flex flex-row  fd:justify-between gap-8 fm:gap-2 items-center">
              <routerLink :to="{name:'Index'}" v-if="$store.state.siteConfig !== null"><img :src="$store.state.siteConfig.store_detail.logo" loading="lazy" alt="" class="w-[150px] h-[40px] fm:w-[80px] fm:h-[20px]"></routerLink>
              <!--          Search product-->
              <Search class="fm:hidden" />
              <!--          End search Product-->
            </div>
            <div class="flex flex-row justify-between items-center fd:gap-4 fm:gap-8">
              <div v-if="!$store.state.user.token">
                <routerLink :to="{name:'Login'}" class="flex flex-row items-center gap-2 fd:border fd:border-gray-300 fd:border-solid fd:p-2 fd:rounded-lg">
                  <span class="rotate-180 flex">
                    <font-awesome-icon icon="fa-solid fa-sign-in-alt" class="icon font-medium fm:text-sm"/>
                  </span>
                  <span class="fm:text-sm">ورود</span>
                  <span class="!font-bold text-xl fm:hidden">|</span>
                  <span class="fm:text-sm fm:hidden">ثبت نام</span>
                </routerLink>
              </div>
              <div v-else>
                <routerLink :to="{name:'Dashboard'}" class="flex flex-row items-center gap-2 fd:border fd:border-gray-300 fd:border-solid fd:p-2 fd:rounded-lg">
                  <span><img src="@/assets/images/dashboard.svg" loading="lazy" alt="" class="w-[20px]"/></span>
                  <span class="fm:text-sm">داشبورد</span>
                </routerLink>
              </div>
              <span class="text-gray-300 text-xl fm:hidden">|</span>
              <div class="relative">
                <div class="flex flex-col gap-2" @click="$store.state.showBasektPoup = !$store.state.showBasektPoup">
                  <span class="text-xl fm:text-sm">
                    <font-awesome-icon icon="fa-solid fa-cart-plus" class="icon font-medium fm:text-sm"/>
                  </span>
                  <div class="absolute top-5">
                    <span class="px-[5px] rounded-full bg-red-400 animate-pulse text-white !font-bold text-xs">{{$store.state.basketCount}}</span>
                  </div>
                </div>

                <div v-if="$store.state.showBasektPoup" class="z-100 absolute h-[500px] scroll overflow-y-scroll w-[28rem] bg-white shadow-lg left-0 top-5 p-3">
                  <div v-if="$store.state.basketData.length > 0" class="flex flex-col gap-2 py-4">
                    <div class="flex gap-4 mb-5" v-for="basket in $store.state.basketData" :key="basket.id">
                      <div class="w-[27%] h-full">
                        <img :src="$store.state.url + basket.image" loading="lazy" alt="" class="rounded w-[72px] h-[72px]"/>
                      </div>
                      <div class="w-full flex flex-col gap-3">
                        <span class="fm:text-sm !font-bold">{{basket.title}}</span>
                        <div class="flex items-center gap-2">
                          <span class="fm:text-sm">{{basket.basket_count}} عدد</span>
                          <span class="fm:text-sm">{{$store.getters.numberFormat(basket.product_price * basket.basket_count)}} ریال</span>
                        </div>
                        <div class="flex items-center gap-2 yellow-bg p-2 rounded">
                          <!-- <span class="text-white fm:text-sm">قیمت ارزش افزوده</span> -->
                          <span class="text-white fm:text-sm">قیمت نهایی</span>
                          <span class="text-white fm:text-sm">{{$store.getters.numberFormat($store.getters.getValueAdded(basket.product_price * basket.basket_count, false))}} ریال</span>
                        </div>
                      </div>
                    </div>
                    <div class="border-b w-full my-4"></div>
                    <div class="flex items-center justify-between w-full">
                      <div class="w-full">
                        <RouterLink :to="{name:'Basket'}" class="w-full flex justify-center items-center rounded fm:text-sm p-2 yellow-bg text-white yellow-bg-hover">
                          پرداخت
                        </RouterLink>
                      </div>
                    </div>
                  </div>
                  <div v-else class="text-center">
                    <span class="fm:text-sm">سبد خرید خالی است</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <!--          Search product-->
          <Search class="fd:hidden" />
          <!--          End search Product-->
          <div :class="['fm:hidden flex justify-between items-center relative z-50 bg-gray-100 rounded-t-lg p-2', scrollY >= 400 && scrollIsDown ? 'hidden' : 'block']">
            <nav>
              <ul class="flex items-center gap-4 list-none py-3">
                <li class="z-100 flex items-center group gap-2 cursor-pointer transition ease-in-out duration-300">
                  <span><font-awesome-icon icon="fa-solid fa-bars" class="icon font-medium fm:text-sm"/></span>
                  <span class="!font-bold text-gray-700">دسته بندی کالاها</span>
                  <div class="hidden group-hover:block absolute w-full bg-gray-300 top-[70%] shadow-lg">
                    <div class="flex bg-gray-200">
                      <div class="w-[22%]  border-l border-gray-300 ml-4 h-[22rem] overflow-y-scroll scroll p-4">
                        <ul class="flex flex-col">
                          <div v-for="category in categories" :key="category.id">
                            <li v-if="category.parent_id === 0" class="flex items-center gap-2 hover:bg-gray-300 rounded p-4 text-black text-sm !font-medium" @mouseover="setCategoryId(category.id, category.title)">
                              <span v-html="category.icon" class="w-[14px] text-gray-400"></span>
                              <span>{{category.title}}</span>
                            </li>
                          </div>
                        </ul>
                      </div>
                      <div class="w-[100%] h-[22rem] overflow-y-scroll scroll">
                        <div v-for="category in categories" :key="category.id">
                          <div v-if="category.id === categoryId" class="p-4">
                            <div class="flex items-center gap-4 mt-3">
                              <routerLink :to="{name:'ProductList',params:{slug:category.slug}}" class="text-sm text-black !font-medium">همه کالاهای {{categoryTitle}}</routerLink>
                              <span class="flex">
                                <font-awesome-icon icon="fa-solid fa-chevron-left" class="icon font-medium text-xs"/>
                              </span>
                            </div>
                            <div class="flex flex-wrap gap-12">
                              <div class="mt-12" v-for="children in category.children" :key="children.id">
                                <div class="flex items-center gap-2">
                                  <span class="yellow-color text-2xl !font-bold">|</span>
                                  <routerLink :to="{name:'ProductList',params:{slug:children.slug}}" class="text-sm text-black !font-medium">{{children.title}}</routerLink>
                                  <span class="flex">
                                    <font-awesome-icon icon="fa-solid fa-chevron-left" class="icon font-medium text-xs"/>
                                  </span>
                                </div>
                                <div>
                                  <ul class="flex flex-col gap-2">
                                    <li  v-for="child in children.children" :key="child.id" class="mt-2 mr-2">
                                      <div class="flex items-center gap-2" v-if="child.children.length > 0">
                                        <span class="yellow-color text-2xl !font-bold">|</span>
                                        <routerLink :to="{name:'ProductList',params:{slug:child.slug}}" class="text-sm text-black !font-medium">{{child.title}}</routerLink>
                                        <span class="flex">
                                          <font-awesome-icon icon="fa-solid fa-chevron-left" class="icon font-medium text-xs"/>
                                        </span>
                                      </div>
                                      <div class="flex items-center gap-2" v-else>
                                        <routerLink :to="{name:'ProductList',params:{slug:child.slug}}" class="text-sm text-black">{{child.title}}</routerLink>
                                      </div>
                                      <ul class="flex flex-col gap-2">
                                        <li  v-for="_child in child.children" :key="_child.id" class="mr-2">
                                          <routerLink :to="{name:'ProductList',params:{slug:_child.slug}}" class="text-black text-sm">{{_child.title}}</routerLink>
                                        </li>
                                      </ul>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </li>
                <li class="flex relative dropdown group items-center gap-2 cursor-pointer transition ease-in-out duration-300 text-gray-600"
                    v-for="category in otherCategories" :key="category.id"
                >
                  <div v-if="category.parent_id === 0" class="flex gap-2 items-center">
                    <span v-html="category.icon" class="w-[14px] text-gray-400"></span>
                    <span>{{category.title}}</span>
                  </div>
                  <NavbarDropdown :childrens="category.children" :isFirstCall="true" :routeName="`${$store.getters.capitalizeFirstLetter(category.type)}List`"/>
                </li>
                <li class="hover:yellow-color transition ease-in-out duration-300">
                  <routerLink :to="{name:'PageDetail',params:{slug:'درباره-ما'}}" class="flex items-center gap-2 text-gray-600">
                    <span>
                      <font-awesome-icon icon="fa-solid fa-info" class="icon text-gray-400 text-xl"/>
                    </span>
                    <span>درباره ما</span>
                  </routerLink>
                </li>
                <li class="hover:yellow-color transition ease-in-out duration-300">
                  <routerLink :to="{name:'ContactUs'}" class="flex items-center gap-2 text-gray-600">
                    <span>
                      <font-awesome-icon icon="fa-solid fa-address-book" class="icon text-gray-400 text-xl"/>
                    </span>
                    <span>تماس با ما</span>
                  </routerLink>
                </li>
                <li class="hover:yellow-color transition ease-in-out duration-300">
                  <routerLink :to="{name:'RepresentativeRequestForm'}" class="flex items-center gap-2 text-gray-600">
                    <span>
                      <font-awesome-icon icon="fa-solid fa-code-pull-request" class="icon text-gray-400 text-xl"/>
                    </span>
                    <span>درخواست نمایندگی</span>
                  </routerLink>
                </li>
                <li class="hover:yellow-color transition ease-in-out duration-300">
                  <routerLink :to="{name:'FaqCategory'}" class="flex items-center gap-2 text-gray-600">
                    <span>
                      <font-awesome-icon icon="fa-solid fa-question-circle" class="icon text-gray-400 text-xl"/>
                    </span>
                    <span> سوالات متداول</span>
                  </routerLink>
                </li>
              </ul>
            </nav>
          </div>
          <div class="fd:hidden">
            <!--            Mobile screen-->
            <div :class="['fixed overflow-y-scroll scroll bg-white shadow w-full top-0 h-screen z-50 ', $store.state.showNav ? 'right-0' : 'right-[-100%]']">
              <div class="text-left p-3 flex items-center justify-between border-b border-gray-200">
                <div class="w-[36%]">
                  <img v-if="$store.state.siteConfig !== null" :src="$store.state.siteConfig.store_detail.logo" loading="lazy" class="w-[138px] h-[56px]" alt="" />
                </div>
                <span @click="$store.state.showNav = false">
                  <font-awesome-icon icon="fa-solid fa-times" class="icon text-gray-400 text-2xl"/>
                </span>
              </div>
              <ul class="mt-3 flex flex-col gap-8 mr-4">
                <li class="cursor-pointer relative">
                  <div>
                    <span class="!font-bold text-gray-700 pr-3 ">دسته بندی کالاها</span>
                  </div>
                  <ul class="w-full bg-white flex flex-col space-y-1 mt-4 relative">
                    <li class="group" v-for="category in categories" :key="category.id">
                      <div v-if="category.parent_id === 0" class="flex items-center justify-between pl-3 gap-1">
                        <span v-html="category.icon" class="w-[14px] text-gray-400"></span>
                        <div class="flex items-center gap-1 w-full justify-between">
                          <routerLink :to="{name:'ProductList',params:{slug:category.slug}}">{{category.title}}</routerLink>
                          <span>
                            <font-awesome-icon icon="fa-solid fa-chevron-left" class="icon group-hover:rotate-[270deg] text-sm text-gray-400 transition ease-in-out duration-300"/>
                          </span>
                        </div>
                      </div>
                      <ul :class="['w-full top-[20px] bg-gray-200 flex-col space-y-4 py-4 hidden group-hover:block']">
                        <li class="relative" v-for="children in category.children" :key="children.id" @click="toggleCategory(children.id)" >
                          <div class="flex items-center justify-between px-8">
                            <routerLink :to="{name:'ProductList',params:{slug:children.slug}}">{{children.title}}</routerLink>
                            <span :class="[showCategory && categoryItem === children.id ? 'rotate-[270deg]' : '']"><i class="fal fa-chevron-left text-sm text-gray-400 transition ease-in-out duration-300"></i></span>
                          </div>
                          <ul :class="['w-full top-[20px] bg-gray-300 flex flex-col space-y-4 py-4', showCategory && categoryItem === j ? 'block' : 'hidden']">
                            <li class="px-16" v-for="child in children.children" :key="child.id">
                              <routerLink :to="{name:'ProductList',params:{slug:child.slug}}">{{child.title}}</routerLink>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>

                <li class="flex relative fm:flex-col dropdown fd:items-center gap-2 cursor-pointer border-b-2 border-white yellow-border-hover transition ease-in-out duration-300 text-gray-600"
                    v-for="category in otherCategories" :key="category.id"
                >
                  <div v-if="category.parent_id === 0" class="flex gap-1 items-center">
                    <span v-html="category.icon" class="w-[14px] text-gray-400"></span>
                    <div class="flex items-center justify-between w-full pl-3">
                      <span class="fm:text-sm !font-medium">{{category.title}}</span>
                      <span>
                        <font-awesome-icon icon="fa-solid fa-chevron-left" class="icon group-hover:rotate-[270deg] text-sm text-gray-400 transition ease-in-out duration-300"/>
                      </span>
                    </div>
                  </div>
                  <NavbarDropdown :childrens="category.children" :isFirstCall="true" :routeName="`${$store.getters.capitalizeFirstLetter(category.type)}List`"/>
                </li>
                <li class="hover:yellow-color transition ease-in-out duration-300">
                  <routerLink to="" class="flex items-center gap-2 text-gray-600">
                    <span>
                      <font-awesome-icon icon="fa-solid fa-info" class="icon text-gray-400"/>
                    </span>
                    <span>درباره ما</span>
                  </routerLink>
                </li>
                <li class="hover:yellow-color transition ease-in-out duration-300">
                  <routerLink :to="{name:'FaqCategory'}" class="flex items-center gap-2 text-gray-600">
                    <span>
                      <font-awesome-icon icon="fa-solid fa-question-circle" class="icon text-gray-400 text-xl"/>
                    </span>
                    <span> سوالات متداول</span>
                  </routerLink>
                </li>
              </ul>
            </div>
            <!--            End mobile screen-->
          </div>
        </div>
        <!--    End nav bar-->
      </div>
    </header>
    <main class="fd:pt-[8rem]" id="main">
      <router-view></router-view>
    </main>

    <footer class="mt-16" v-if="$store.state.siteConfig !== null">
      <div class="mx-4 border p-3 rounded-lg">
        <div class="flex flex-col gap-5">
          <div>
            <img :src="$store.state.siteConfig.store_detail.footer_logo" loading="lazy" alt="" class="w-[305px] h-[100px]" />
          </div>
          <div class="flex flex-row gap-3 fm:flex-col fd:items-center">
            <span class="fm:text-sm">تلفن پشتیبانی {{ $store.state.siteConfig.store_detail.support_phone }}</span>
            <span class="fm:hidden">|</span>
            <span class="fm:text-sm">۷ روز هفته، ۲۴ ساعته پاسخگوی شما هستیم</span>
          </div>
        </div>
        <div class="flex justify-around  mt-20 fm:hidden">
          <div class="flex flex-col gap-2 items-center">
            <div>
              <img src="@/assets/temImage/express-delivery.png" loading="lazy" class="w-[55px] h-[55px]" alt=""/>
            </div>
            <div>
              <span class="text-sm">اﻣﮑﺎن ﺗﺤﻮﯾﻞ اﮐﺴﭙﺮس</span>
            </div>
          </div>
          <div class="flex flex-col gap-2 items-center">
            <div>
              <img src="@/assets/temImage/cash-on-delivery.png" loading="lazy" class="w-[55px] h-[55px]" alt=""/>
            </div>
            <div>
              <span class="text-sm">امکان پرداخت در محل</span>
            </div>
          </div>
          <div class="flex flex-col gap-2 items-center">
            <div>
              <img src="@/assets/temImage/support.png" loading="lazy" class="w-[55px] h-[55px]" alt=""/>
            </div>
            <div>
              <span class="text-sm">۷ روز ﻫﻔﺘﻪ، ۲۴ ﺳﺎﻋﺘﻪ</span>
            </div>
          </div>
          <div class="flex flex-col gap-2 items-center">
            <div>
              <img src="@/assets/temImage/days-return.png" loading="lazy" class="w-[55px] h-[55px]" alt=""/>
            </div>
            <div>
              <span class="text-sm">هفت روز ضمانت بازگشت کالا</span>
            </div>
          </div>
          <div class="flex flex-col gap-2 items-center">
            <div>
              <img src="@/assets/temImage/original-products.png" loading="lazy" class="w-[55px] h-[55px]" alt=""/>
            </div>
            <div>
              <span class="text-sm">ﺿﻤﺎﻧﺖ اﺻﻞ ﺑﻮدن ﮐﺎﻟﺎا</span>
            </div>
          </div>
        </div>
        <div class="flex justify-around fm:flex-wrap mt-20">
          <div>
            <div>
              <span class="text-2xl !font-bold fm:text-lg">با {{$store.state.siteName}}</span>
            </div>
            <ul class="flex flex-col space-y-4 mt-6">
              <li class="text-gray-500"><routerLink  :to="{name:'ContactUs'}">تماس با {{$store.state.siteName}}</routerLink></li>
              <li class="text-gray-500"><routerLink  :to="{name:'FaqCategory'}">پرسش و پاسخ های متداول</routerLink></li>
            </ul>
          </div>
          <div class="fm:hidden">
            <div>
              <span class="text-2xl !font-bold fm:text-lg">خدمات مشتریان و راهنمای خرید</span>
            </div>
            <ul class="flex flex-col space-y-4 mt-6">
              <li v-for="page in pages" :key="page.id" class="text-gray-500"><routerLink :to="{name:'PageDetail', params:{slug:page.slug}}">{{ page.title }}</routerLink></li>
            </ul>
          </div>
          
          <div class="fm:mt-10">
            <div class="">
              <span class="text-2xl !font-bold fm:text-lg">همراه ما باشید!</span>
            </div>
            <div class="flex flex-col gap-6 mt-6">
              <div>
                <ul class="flex flex-row gap-4 items-center">
                  <li>
                    <a target="_blank" :href="$store.state.siteConfig.social_media !== null ? $store.state.siteConfig.social_media.instagram : '#'">
                      <span>
                        <font-awesome-icon icon="fa-brands fa-instagram" class="icon text-4xl text-red-500"/>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" :href="$store.state.siteConfig.social_media !== null ? $store.state.siteConfig.social_media.twitter : '#'">
                      <span>
                        <font-awesome-icon icon="fa-brands fa-twitter" class="icon text-4xl text-green-500"/>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" :href="$store.state.siteConfig.social_media !== null ? $store.state.siteConfig.social_media.telegram : '#'">
                      <span>
                        <font-awesome-icon icon="fa-brands fa-telegram" class="icon text-4xl text-blue-500"/>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" :href="$store.state.siteConfig.social_media !== null ? $store.state.siteConfig.social_media.whatsapp : '#'">
                      <span>
                        <font-awesome-icon icon="fa-brands fa-whatsapp" class="icon text-4xl text-green-500"/>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a target="_blank" :href="$store.state.siteConfig.social_media !== null ? $store.state.siteConfig.social_media.facebook : '#'">
                      <span>
                        <font-awesome-icon icon="fa-brands fa-facebook" class="icon text-4xl text-yellow-400"/>
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
              <div class="flex flex-col gap-3">
                <div>
                <span class="fm:text-sm">
                  همراه ما باشید!
                  با ثبت ایمیل، از جدید‌ترین های ما با‌خبر شوید
                </span>
                </div>
                <div class="flex items-center justify-between gap-4">
                  <input type="text" class="w-full p-3 rounded-lg outline-none bg-gray-100" v-model="newsletter" placeholder="ایمیل شما"/>
                  <div v-if="newsletter.length > 0">
                    <Button text="ثبت" :btnLoading="btnLoading" @callback="sendNewsletter()"></Button>
                  </div>
                  <div v-else>
                    <Button text="ثبت" :btnLoading="false" my_class="!bg-gray-300"></Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-between fm:flex-col gap-8 mt-20">
          <div class="flex flex-col gap-3 fd:w-[50%]">
            <div>
              <span class="text-2xl fm:text-lg !font-bold">{{$store.state.siteName}}</span>
            </div>
            <div>
              <p class="break-word fm:text-sm" v-html="$store.state.siteConfig.store_detail.site_bio"></p>
            </div>
          </div>
          <div class="flex justify-end gap-3 fd:w-[50%]">
            <div class="w-[75px]">
              <img src="@/assets/images/dandesh_bonyan.png" class="border border-gray-200 rounded p-3" />
            </div>
            <div class="w-[75px]" v-if="$store.state.siteConfig.store_detail.enamad !== null">
              <div class="h-full border border-gray-200 rounded p-3" v-html="$store.state.siteConfig.store_detail.enamad"></div>
            </div>
            <div class="w-[75px]" v-if="$store.state.siteConfig.store_detail.samandehi !== null">
              <div class="h-full border border-gray-200 rounded p-3" v-html="$store.state.siteConfig.store_detail.samandehi"></div>
            </div>
            <div class="w-[75px]" v-if="$store.state.siteConfig.store_detail.mojavez !== null">
              <div class="h-full border border-gray-200 rounded p-3" v-html="$store.state.siteConfig.store_detail.mojavez"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-10 text-center p-5">
        <span class="text-md fm:text-sm">{{ $store.state.siteConfig.store_detail.copy_right }}</span>
      </div>
    </footer>
    <ValidationError />
  </div>
</template>

<script>
export default {name: "FrontLayout"}
</script>

<script setup>
import {ref, onMounted} from "vue";
import Search from '@/components/Search.vue';
import NavbarDropdown from '@/components/NavbarDropdown.vue';
import Button from '@/components/Button.vue';
import ValidationError from '@/components/ValidationError.vue';
import store from "@/store";
import axios from "@/plugins/axios";
import Toast from "@/plugins/toast";

let btnLoading = ref(false);
let showCategory = ref(false);
let categoryItem = ref(0);
let categoryId = ref(1);
let scrollY = ref(0);
let scrollIsDown = ref(false);
let prevScroll = 0;
let categoryTitle = ref('');
let categories = ref([]);
let pages = ref([]);
let otherCategories = ref([]);
let newsletter = ref('');


onMounted(async () => {
  await indexHeader()
  let uuid = localStorage.getItem('basket_uuid')
  if(uuid !== ''){
    await store.dispatch('getBasket',{uuid:localStorage.getItem('basket_uuid')})
  }else{
    store.state.basketCount = 0
  }
  window.addEventListener('scroll', yScroll)
  window.addEventListener('scroll', doesItScrollDown)
  getPages()
})

async function indexHeader(){
  await axios.get(`${store.state.api}index-header`).then(resp=>{
    let data = resp.data.data;
    categories.value = data.categories;
    otherCategories.value = data.other_categories;
    if(categories.value.length > 0){
      let _category = categories.value[0];
      categoryTitle.value = _category.title;
      categoryId.value = _category.id
    }
    store.state.siteConfig = {'store_detail':data.store_detail, 'social_media':data.social_media};
    if(store.state.siteConfig !== null){
      store.state.valueAdded = data.store_detail.value_added
      store.state.siteConfig.store_detail.value_added = parseInt(store.state.siteConfig.store_detail.value_added)
      store.state.siteName = store.state.siteConfig.store_detail.site_name_ir
      store.dispatch('setFavicon',store.state.siteConfig.store_detail.favicon)
    }

  }).catch(err=>{})
}

function getPages() {
  axios.get(`${store.state.api}get-pages`).then(resp=>{
    pages.value = resp.data.data;
  }).catch(err=>{
    store.commit('handleError',err)
  })
}

async function sendNewsletter(){
  btnLoading.value = true;
  await axios.post(`${store.state.api}add-newsletter`,{email:newsletter.value}).then(resp=>{
    Toast.success("با موفقیت ثبت شد");
    newsletter.value = '';
  }).catch(err=>{
    store.commit('handleError',err)
  })
  btnLoading.value = false;
}

function setCategoryId(id, title){
  categoryId.value = id;
  categoryTitle.value = title;
}
function toggleCategory(item){
  showCategory.value = categoryItem.value !== item && showCategory.value ? true : !showCategory.value;
  categoryItem.value = item;
}
function yScroll(){
  scrollY.value = window.scrollY
}
function doesItScrollDown() {
  scrollIsDown.value = prevScroll < window.scrollY;
  prevScroll = window.scrollY
}
</script>